import { ASSET_TYPES } from '@/services/AssetService/config';
import Env from '@/helpers/Env';
import { getUrlFloat, getUrlBoolean, getUrlString } from '@/helpers/UrlParam';

// **********************************************************************
// URLS
// **********************************************************************
export const fonts = {};

export const models = {};

export const images = {};

export const textures = {
  t_barley: `assets/textures-o/area1/barley.ktx2`,
  t_bird: `assets/textures-o/area1/bird.ktx2`,
  t_cow: `assets/textures-o/area1/cow-spritesheet.ktx2`,
  t_shed: `assets/textures-o/area1/shed.ktx2`,
  t_sign: `assets/textures-o/area1/sign.ktx2`,

  // t_score_1: `assets/textures-o/area1/score_1.ktx2`,
  t_score_1: `assets/textures-o/area3/score_3.ktx2`,
};

export const jsons = {};

export const sounds = {};

const videos = {};

export const urls = {
  ...fonts,
  ...models,
  ...images,
  ...textures,
  ...sounds,
  ...videos,
};

// **********************************************************************
// MANIFEST
// **********************************************************************
export const manifest = {
  id: 'farm',
  items: [
    ...Object.entries(fonts).map(([id, url]) => ({ id, url })),
    ...Object.entries(models).map(([id, url]) => ({ id, url })),
    ...Object.entries(images).map(([id, url]) => ({ id, url })),
    ...Object.entries(textures).map(([id, url]) => ({ id, url })),
    ...Object.entries(sounds).map(([id, url]) => ({ id, url })),
    ...Object.entries(jsons).map(([id, url]) => ({ id, url })),
    ...Object.entries(videos).map(([id, url]) => ({ id, url })),
  ],
};
